import type { WhiteLabel } from '@skytech/types'
import type { Location } from 'react-router-dom'

export const getWhiteLabelFromParams = ({
  location,
  setWhiteLabel,
}: {
  location: Location
  setWhiteLabel: (whiteLabel: WhiteLabel) => void
}) => {
  const nextPath = new URLSearchParams(location.search).get('next')?.toLowerCase() || ''
  const nextSearchParams = new URL(window.location.origin + nextPath).searchParams
  const locallyStoredWhiteLabel = localStorage.getItem('org') as WhiteLabel

  if (nextSearchParams.get('ice') !== null) {
    setWhiteLabel('ice')
  } else if (
    nextSearchParams.get('mobit') !== null ||
    window.location.hostname.includes('mobit.no')
  ) {
    setWhiteLabel('mobit')
  } else if (
    nextSearchParams.get('bechtle') !== null ||
    window.location.hostname.includes('bechtle.skytechcontrol.io')
  ) {
    setWhiteLabel('bechtle')
  } else if (nextSearchParams.get('elkjop') !== null) {
    setWhiteLabel('elkjop')
    // Backward compatibility for the old company name
  } else if (nextSearchParams.get('evry') !== null) {
    setWhiteLabel('tietoevry')
  } else if (nextSearchParams.get('tietoevry') !== null) {
    setWhiteLabel('tietoevry')
  } else if (nextSearchParams.get('csi') !== null) {
    setWhiteLabel('csi')
  } else if (nextSearchParams.get('telia') !== null) {
    setWhiteLabel('telia')
  } else if (nextSearchParams.get('threestepit') !== null) {
    setWhiteLabel('threeStepIT')
  } else if (nextSearchParams.get('3stepit') !== null) {
    setWhiteLabel('threeStepIT')
  } else if (nextSearchParams.get('komplett') !== null) {
    setWhiteLabel('komplett')
  } else if (nextSearchParams.get('ikomm') !== null) {
    setWhiteLabel('ikomm')
  } else {
    if (!locallyStoredWhiteLabel) {
      setWhiteLabel('skytech')
      return
    }

    if (locallyStoredWhiteLabel === 'tcm' || locallyStoredWhiteLabel === 'control') {
      setWhiteLabel('skytech')
      return
    }

    setWhiteLabel(locallyStoredWhiteLabel)
  }
}

export const getWhiteLabelBasedOnId = (id: number): WhiteLabel => {
  switch (id) {
    case 9:
      return 'mobit'
    case 10:
      return 'bechtle'
    case 11:
      return 'elkjop'
    case 12:
      return 'telia'
    case 13:
      return 'csi'
    case 16:
      return 'threeStepIT'
    case 17:
      return 'komplett'
    case 18:
      return 'ikomm'
    default:
      return 'skytech'
  }
}

export const getWhiteLabel = (whiteLabel: WhiteLabel | null) => {
  switch (whiteLabel) {
    case 'mobit':
      return 'mobit'
    case 'bechtle':
      return 'bechtle'
    case 'elkjop':
      return 'elkjop'
    case 'csi':
      return 'csi'
    case 'telia':
      return 'telia'
    // Backward compatibility for the old company name
    case 'evry':
      return 'tietoevry'
    case 'tietoevry':
      return 'tietoevry'
    // Backward compatibility for the old company name
    case 'tcm':
      return 'skytech'
    // Backward compatibility for the old company name
    case 'control':
      return 'skytech'
    case 'skytech':
      return 'skytech'
    case 'threeStepIT':
      return 'threeStepIT'
    case 'komplett':
      return 'komplett'
    case 'ikomm':
      return 'ikomm'
    default:
      return 'skytech'
  }
}

export const companyNamesByWhiteLabelId: Record<string, string> = {
  1: 'Skytech Control AS',
  3: 'Evry AS',
  6: 'Nordialog',
  5: 'Ice.net',
  7: 'Telehuset',
  8: 'Telenor Ucom AS',
  9: 'Mobit',
  10: 'Bechtle',
  11: 'Elkjøp',
  12: 'Telia',
  13: 'CSI',
  14: 'SkyT Control AB',
  15: 'Telia incl application deadline',
  16: '3 Step IT',
  17: 'Komplett',
  18: 'IKOMM',
}

export const ALLOWED_WHITE_LABELS_FOR_DEALER = [
  'control',
  'skytech',
  'tcm',
  'mobit',
  'bechtle',
  'csi',
  'elkjop',
]

export const getWhiteLabelForDealerStyle = (whiteLabel: WhiteLabel): WhiteLabel =>
  ALLOWED_WHITE_LABELS_FOR_DEALER.includes(whiteLabel) ? whiteLabel : 'control'

export const WHITE_LABEL_LIST: WhiteLabel[] = [
  'control',
  'ice',
  'mobit',
  'bechtle',
  'csi',
  'elkjop',
  'evry',
  'telia',
  'tietoevry',
  'skytech',
  'tcm',
  'arp',
  'threeStepIT',
  'komplett',
  'ikomm',
]
